import { createAction, createAsyncAction } from 'typesafe-actions';
import { Location } from './types';

export const fetchLocations = createAsyncAction(
  'locations/FETCH_REQUEST',
  'locations/FETCH_SUCCESS',
  'locations/FETCH_FAILURE'
)<void, Location[], Error>();

export const updateLocations = createAction('locations/UPDATE_LOCATIONS', resolve =>
  (location: Location) => resolve(location)
);

export const setRefresh = createAction('locations/SET_REFRESH', resolve =>
  (refresh: boolean) => resolve(refresh)
);

export const getParksRequest = createAsyncAction(
  'places/GET_PARKS_REQUEST',
  'places/GET_PARKS_SUCCESS',
  'places/GET_PARKS_FAILURE'
)<void, Location[], Error>();

export const getParks = () => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(getParksRequest.request());
      return fetch('/data/parks.min.json')
        .then(response => response.json())
        .then((json) => {
          const list: Location[] = json.data.filter((item: any) => {
            return (item.lat && item.lng)
          });
          dispatch(getParksRequest.success(list));
        });
    });
  }
}